import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Private adventure review link (?review=TOKEN): lets the owner preview unpublished adventure
// content anonymously (read-only). Kept for this browser tab only.
try {
  const r = new URLSearchParams(window.location.search).get("review");
  if (r) sessionStorage.setItem("gk_review", r);
} catch { /* ignore */ }
export const reviewToken = () => { try { return sessionStorage.getItem("gk_review") || ""; } catch { return ""; } };
export const reviewQS = () => (reviewToken() ? `&review=${encodeURIComponent(reviewToken())}` : "");
api.interceptors.request.use((cfg) => {
  const t = reviewToken();
  if (t) cfg.headers["X-Review-Token"] = t;
  return cfg;
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return "Something went wrong. Please try again.";
}
